/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ApartmentPositionOutput.vue?vue&type=template&id=b681578e"
import script from "./ApartmentPositionOutput.vue?vue&type=script&setup=true&lang=ts"
export * from "./ApartmentPositionOutput.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports